import { put, call } from 'redux-saga/effects';
import { userDocMasterList, userDocList, userDocAdd, userDocEdit, userDocUpdate, userDocDelete } from '../../services/settings/userDocService';

import * as types from '../../actions';

export function* userDocMasterListSaga(payload) {
  try {
    const response = yield call(userDocMasterList, payload);
    yield put({ type: types.USER_DOC_MASTER_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.USER_DOC_MASTER_LIST_ERROR, error });
  }
}

export function* userDocListSaga(payload) {
    try {
      const response = yield call(userDocList, payload);
      yield put({ type: types.USER_DOC_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.USER_DOC_LIST_ERROR, error });
    }
}

export function* userDocAddSaga(payload) {
  console.log('userDocAddSaga   userDocAddSaga'); 
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(userDocAdd, payload);
      yield put({ type: types.USER_DOC_ADD_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.USER_DOC_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* userDocEditSaga(payload) {
  try {
    const response = yield call(userDocEdit, payload);
    yield put({ type: types.USER_DOC_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.USER_DOC_EDIT_ERROR, error });
  }
}

export function* userDocUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(userDocUpdate, payload);
    yield put({ type: types.USER_DOC_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.USER_DOC_UPDATE_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* userDocDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(userDocDelete, payload);
    yield put({ type: types.USER_DOC_DELETE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.USER_DOC_DELETE_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}